module.exports = __webpack_public_path__ + "ea005913bcb72f246fc8aa5f997d846e.svg";